<template>
  <div class="main">
    <Nav :authRequired = "true"/>
    <div class="container">
      <div class="row mb-x2">
        <div class="col d-flex justify-content-between align-items-center">
          <h2>Users</h2>
          <router-link to="/users/create" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline">
            <i class="fas fa-plus mr-x1"></i>Add a User
          </router-link>
        </div>
      </div>
      <div class="row mb-x4">
        <div class="col">
          <div class="row">
            <div class="col-12 mb-x2" v-for="(user, index) in users" :key="index">
              <div class="zero-card d-flex justify-content-between">
                <div class="d-flex">
                  <div class="avatar-image lg avatar-background mr-x2" :style="{ backgroundImage: 'url(' + filePath + 'uploads/profiles/' + user.userimage + ')' }">
                    <span v-if="!user.userimage">{{ user.name[0] }}</span>
                  </div>
                  <div>
                    <h6>{{ user.name }}</h6>
                    {{ user.email }}
                    <div v-if="user.permissions" class="mt-x1">
                      <i class="fas fa-users mr-x1" title="user admin" v-if="user.permissions[0] == '1'"></i>
                      <i class="fas fa-edit mr-x1" title="editor" v-if="user.permissions[1] == '1'"></i>
                      <i class="fas fa-eye mr-x1" title="viewer" v-if="user.permissions[2] == '1'"></i>
                      <i class="fas fa-medal" title="first user" v-if="user.permissions[3] == '1'"></i>
                    </div>
                  </div>
                </div>
                <div>
                  <router-link :to="'/users/' + user.id" class="">
                    Details
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Nav from '@/components/Nav.vue'

Vue.use(VueCookies)
// import shared from '@/shared.js'
// example usage: shared.parseDate('2012-08-11')
const axios = require('axios')

// endpoints
const apiChoice = process.env.VUE_APP_API_URL

export default {
  name: 'cmsadmin',
  components: {
    Nav
  },
  data () {
    return {
      isLoading: false,
      userToken: '',
      isLoggedIn: false,
      users: [],
      filePath: apiChoice
    }
  },
  created () {
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
      this.getUsers()
    }
  },
  methods: {
    getUsers () {
      this.isLoading = true
      axios
        .get(apiChoice + 'api/users', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // transfer the response
          this.users = response.data
        })
        .catch((error) => {
          console.log(error.response.data)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content .menu-info{
  h2{
    display: block;
  }
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
